export default "__VITE_ASSET__DRvhDUXO__"